// 'CAB.LIN[]' -> true
// 'CAB.LIN[1]' -> true

export function _isArray(field = '') {
  const lastChar = field.slice(-1);
  if (lastChar === ']') {
    return true;
  }
  return false;
}
